import React from "react";
import styled from "styled-components";
import Logo from "../Logo";

const Wrapper = styled.header`
  margin: 0 auto;
  max-width: 900px;
  padding: 20px;
`;

const Header = () => (
  <Wrapper>
    <Logo />
  </Wrapper>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.jsx